import React from 'react'
import styled from 'styled-components'
import { createResource, useResource } from '@/lib/i18n'
import Link from 'next/link'
import Image from 'next/image'
import LazyLoad from 'react-lazyload'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'
import { resolveURL } from '@/lib/utils'
import { OtherUrl } from '@/lib/enums/pages'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'

const resource = createResource({
  en: {
    desc: 'Check My Pintar Score',
  },
  id: {
    desc: 'Periksa Skor Pintar Saya',
  },
})

const GooglePlay = () => {
  const { t } = useResource(resource)
  const h5Website = resolveURL(OtherUrl.PINTARSCORE)
  const h5PointarShop = resolveURL(OtherUrl.PINTARSHOP)
  const { width } = useWindowSize()
  const isFromMobile = width < 1000

  const eventClick = () => {
    if (isFromMobile) {
      eventLogProducer.push({
        action: Action.CHECKMYPINTARSCOREBADGECLICK,
      })
      window.location.href = h5Website
    }
  }
  const goToPointarShop = () => {
    eventLogProducer.push({
      action: Action.PINTARSHOPBADGECLICK,
    })
    window.location.href = h5PointarShop
  }
  return (
    <Button role="button" aria-disabled="false">
      <div className="google-btn">
        {isFromMobile ? (
          <>
            <Link href={h5Website}>
              <a onClick={eventClick} rel="noopener noreferrer nofollow" target="_blank" className="google-link">
                <div className="download">
                  <LazyLoad>
                    <Image
                      width={164}
                      height={164}
                      quality={85}
                      placeholder="empty"
                      className="google-icon"
                      src={`/images/home/pintar-score-mobile-icon.png`}
                      alt="download-google-play"
                    />
                  </LazyLoad>
                  <p className="desc">{t('desc')}</p>
                </div>
              </a>
            </Link>
            <Link href={h5PointarShop}>
              <a onClick={goToPointarShop} rel="noopener noreferrer nofollow" target="_blank" className="google-link">
                <div className="download">
                  <LazyLoad>
                    <Image
                      width={164}
                      height={164}
                      quality={85}
                      placeholder="empty"
                      className="google-icon"
                      src={`/images/home/pintar-shop-icon.png`}
                      alt="download-pintar-shop"
                    />
                  </LazyLoad>
                </div>
              </a>
            </Link>
          </>
        ) : (
          <Link href={'/pintar-score'}>
            <a className="google-link" onClick={eventClick}>
              <div className="download">
                <LazyLoad>
                  <Image
                    width={164}
                    height={164}
                    quality={85}
                    placeholder="empty"
                    className="google-icon"
                    src={`/images/home/pintar-score-icon.png`}
                    alt="download-google-play"
                  />
                </LazyLoad>
                <p className="desc">{t('desc')}</p>
              </div>
            </a>
          </Link>
        )}
      </div>
    </Button>
  )
}

const Button = styled.div`
  @media only screen and (max-width: 1000px) {
    .google-btn {
      position: fixed;
      right: 0;
      top: 66%;
      transform: translateY(-41%);
      z-index: 9999;
      .google-link {
        display: block;
        .download {
          color: #fff;
          font-size: 14px;
          text-align: right;
          text-align: center;
          width: 70px;
          height: 70px;
          .google-icon {
            position: relative;
            right: 0;
            width: 88px;
          }
          .desc {
            display: none;
          }
        }
      }
    }
    .google-btn:hover .download {
      opacity: 1;
    }
  }

  @media only screen and (min-width: 1000px) {
    .google-btn {
      position: fixed;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 9999;
      .google-link {
        display: block;
        .download {
          position: relative;
          top: 15px;
          right: 10px;
          color: #fff;
          font-size: 14px;
          text-align: right;
          text-align: center;
          width: 164px;
          height: 164px;
          .google-icon {
            position: relative;
            right: 0;
            width: 164px;
          }
          .desc {
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 14px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            white-space: nowrap;
          }
        }
      }
    }
    .google-btn:hover .download {
      opacity: 1;
    }
  }
`

export default GooglePlay
